import { useState } from "react";
import { BookOpen, Headphones } from "lucide-react";
import { api } from "@/lib/api";
import { CoverImage } from "@/components/CoverImage";
import { useLang } from "@/context/LangContext";

const btn = "flex-1 inline-flex items-center justify-center gap-1.5 rounded-full px-3 py-2.5 text-sm font-semibold transition-colors";

export const SampleCard = ({ s, onOpen }) => {
  const { t } = useLang();
  const [coverOk, setCoverOk] = useState(true);
  return (
    <article className="flex flex-col" data-testid={`sample-card-${s.id}`}>
      <button onClick={() => onOpen(s, false)} className={`relative aspect-[4/3] rounded-sm overflow-hidden ${coverOk ? "bg-white ring-1 ring-[#E5DCCB]" : "bg-[#3B2F25]"} shadow-[0_20px_40px_-20px_rgba(28,25,23,0.6)] text-start group`}
        aria-label={`${t.samples.read} ${s.title}`} data-testid={`sample-cover-btn-${s.id}`}>
        {coverOk && <CoverImage src={`${api.defaults.baseURL}/books/${s.id}/cover?v=2`} alt={s.title} onError={() => setCoverOk(false)} testid={`sample-cover-${s.id}`} hoverZoom />}
        {!coverOk && <span className="absolute top-2 start-2 text-[11px] font-bold text-amber-100 bg-black/60 rounded-full px-2.5 py-0.5">
          {t.lib.level} {s.level} · {t.levels[s.level]}
        </span>}
        {!coverOk && <h3 dir={s.dir} className="absolute bottom-5 inset-x-5 text-2xl font-bold text-[#FAF7F2]">{s.title}</h3>}
      </button>
      {s.title && <p className="mt-3 font-semibold text-[#1C1917] line-clamp-2" dir="auto" data-testid={`sample-title-${s.id}`}>{s.title}</p>}
      <p className="mt-1 text-sm text-stone-600" data-testid={`sample-pages-${s.id}`}>{s.page_count} {t.lib.pages}</p>
      <div className="mt-3 hidden sm:flex flex-row gap-2">
        <button onClick={() => onOpen(s, false)} data-testid={`sample-read-btn-${s.id}`} className={`${btn} bg-[#1C1917] text-[#FAF7F2] hover:bg-[#8B3A2B]`}>
          <BookOpen className="w-4 h-4" /> {t.samples.read}
        </button>
        <button onClick={() => onOpen(s, true)} data-testid={`sample-listen-btn-${s.id}`} className={`${btn} border border-[#1C1917] hover:bg-[#1C1917] hover:text-[#FAF7F2]`}>
          <Headphones className="w-4 h-4" /> {t.reader.listen}
        </button>
      </div>
    </article>
  );
};
